export default "__VITE_ASSET__bOau$b3g__"